import IApiError from "@/app/model/IApiError";
import IOtpResponse from "@/app/dto/IOtpResponse";

export default class OtpResult {
    constructor(public data?: IOtpResponse, public error?: IApiError) {
    }
}
